import { Component, h } from '@stencil/core';


@Component({
    tag: 'lilu-inspiration-grid',
    styleUrl: 'lilu-inspiration-grid.scss',
    shadow: true
})
export class LiluInspirationGrid {

    render() {
        return (
          <section class="inspirations">
              <div class={`grid columns-4`}>
                  <slot></slot>
              </div>
          </section>
        );
    }
}
